import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Body1, HeaderBlock } from '@fs/zion-ui'
import Head, { Title } from '@fs/zion-head'
import PersonPageBanner from '@fs/tree-person-page-banner'
import PersonNotFound from './PersonNotFound.svg'

const imageCss = css`
  background-image: url(${PersonNotFound});
  background-color: #c4c4c4;
  background-position: center bottom;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100vh;
`
const errorCss = css`
  text-align: center;
  margin-top: 50px;
`

const person = {
  name: undefined,
  gender: 'UNKNOWN',
}

export default function GoneError(): JSX.Element {
  const [t] = useTranslation()

  return (
    <div css={imageCss}>
      <Head>
        <meta httpEquiv="status" content="410 Gone" />
      </Head>
      <Title>{`${t('ancestors.error-page.meta-data.title', 'Ancestors in Family Tree')} | ${t(
        'ancestors.gone-error.header',
        "Person's Record Is Removed"
      )}`}</Title>
      <PersonPageBanner person={person} notFound />
      <div data-testid="gone-error" css={errorCss}>
        <HeaderBlock heading={t('ancestors.gone-error.header', 'Person’s Record Is Removed')} size="md" />
        <Body1>
          {t(
            'ancestors.gone-error.text',
            "The person's record you requested has either been removed or merged into another record. Please try your search again. You may find a different record about this person."
          )}
        </Body1>
      </div>
    </div>
  )
}
